import React from 'react';
import PropTypes from 'prop-types';
import { Table, Message, Header } from 'semantic-ui-react';
import IneligiblePurchasesListRow from './ListRow';

const IneligiblePurchasesList = ({
  onSelectGuarantee, items, selectedProduct, canForceGuarantee,
}) => {
  const listRow = IneligiblePurchasesListRow(
    onSelectGuarantee,
    selectedProduct,
    canForceGuarantee
  );

  if (!items || items.length === 0) {
    return (
      <div>
        <Header>Ineligible Purchases</Header>
        <Message info content='No data found.' />
      </div>
    );
  }

  const headerRow = (
    <Table.Row>
      <Table.HeaderCell>VIN</Table.HeaderCell>
      <Table.HeaderCell>Attempted At</Table.HeaderCell>
      <Table.HeaderCell>Dealer Number</Table.HeaderCell>
      <Table.HeaderCell>Auction (name/sale/lane/run)</Table.HeaderCell>
      <Table.HeaderCell>Vehicle</Table.HeaderCell>
      <Table.HeaderCell>Odometer (M)</Table.HeaderCell>
      <Table.HeaderCell>Vehicle Purchase Price</Table.HeaderCell>
      <Table.HeaderCell>Failure Reason</Table.HeaderCell>
      <Table.HeaderCell>Product</Table.HeaderCell>
      <Table.HeaderCell />
    </Table.Row>
  );

  return (
    <div>
      <Header>Ineligible Purchases</Header>
      <div>
        <Table
          celled
          selectable
          padded
          renderBodyRow={listRow}
          tableData={items}
          headerRow={headerRow}
          size='small'
          compact='very'
          style={{ fontSize: '90%' }}
          striped
        />
      </div>
    </div>
  );
};

IneligiblePurchasesList.propTypes = {
  onSelectGuarantee: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedProduct: PropTypes.string,
  canForceGuarantee: PropTypes.bool,
};

IneligiblePurchasesList.defaultProps = {
  selectedProduct: null,
  canForceGuarantee: false,
};

export default IneligiblePurchasesList;
